var map = {
	"./1 - Allah Las - Raspberry Jam.mp3": 133,
	"./10 - The Floaters - Float On.mp3": 134,
	"./100 - Allah-Las - Catamaran.mp3": 135,
	"./11 - Genesis Owusu - Wit' Da Team.mp3": 136,
	"./12 - Phillipi & Rodrigo - Minas.mp3": 137,
	"./13 - Bakar - Unhealthy.mp3": 138,
	"./14 - Brenton Wood - Gimme Little Sign.mp3": 139,
	"./15 - KAYTRANADA - 10 percent.mp3": 140,
	"./16 - Rosalía - Dolerme.mp3": 141,
	"./17 - Jimmy Cliff - I Can See Clearly Now.mp3": 142,
	"./18 - Carlton williams - Prison Song.mp3": 143,
	"./19 - Drugdealer - Honey.mp3": 144,
	"./2 - Tierra Whack - Only Child.mp3": 145,
	"./20 - Unknown Mortal Orchestra - Hunnybee.mp3": 146,
	"./21 - Laid Back - Bakerman.mp3": 147,
	"./22 - 21 Savage - a lot.mp3": 148,
	"./23 - Steve Lacy - Dark Red.mp3": 149,
	"./24 - Dram - Broccoli (feat. Lil Yachty).mp3": 150,
	"./25 - Frank Ocean - In My Room.mp3": 151,
	"./26 - Saint DX - Prime of Your Life.mp3": 152,
	"./27 - Africa Express - Johannesburg.mp3": 153,
	"./28 - LA Priest - What Moves (Edit).mp3": 154,
	"./29 - Iwabo - Reggae Down.mp3": 155,
	"./3 - Delegation - Darlin I Think About U.mp3": 156,
	"./30 - Bob Marley & The Wailers - Iron Lion Zion.mp3": 157,
	"./31 - Arizona Zervas - ROXANNE.mp3": 158,
	"./32 - Jungle - Heavy, California.mp3": 159,
	"./33 - George Harrison - Love Comes To Everyone.mp3": 160,
	"./34 - Jurassic 5 - Thin Line.mp3": 161,
	"./35 - Chicago - If You Leave Me Now.mp3": 162,
	"./36 - Nino Ferrer - Looking For You.mp3": 163,
	"./37 - Sade - Smooth Operator (Single Version).mp3": 164,
	"./38 - Chaka Khan - Fate (WSM Compilation Edit).mp3": 165,
	"./39 - Sister Sledge - Thinking of You.mp3": 166,
	"./4 - Juan Wauters - Todo Terminó.mp3": 167,
	"./40 - Carly Simon - Why.mp3": 168,
	"./41 - Claudia Barry - Love for the Sake of Love.mp3": 169,
	"./42 - Oliver Cheatham - Get Down Saturday Night.mp3": 170,
	"./43 - Tom Tom Club - Genius Of Love.mp3": 171,
	"./44 - Grace Jones - My Jamaican Guy.mp3": 172,
	"./45 - Juca Chaves - Take Me Back To Piauí.mp3": 173,
	"./46 - Cheryl Lynn - Got to Be Real (Single Version).mp3": 174,
	"./47 - UB40 - Kingston Town.mp3": 175,
	"./48 - Mtume - Juicy Fruit.mp3": 176,
	"./49 - Leo Sayer - Easy To Love.mp3": 177,
	"./5 - Catastrophe - Maintenant ou jamais.mp3": 178,
	"./50 - Jill Scott - Gotta Get Up (Another Day).mp3": 179,
	"./51 - Guts - Brand New Revolution.mp3": 180,
	"./52 - Chemise - She Can't Love You.mp3": 181,
	"./53 - Roudoudou - Peace and tranquility to earth.mp3": 182,
	"./54 - New Paradise - I Love Video.mp3": 183,
	"./55 - Paul Martin - Le troublant témoignage de Paul Martin.mp3": 184,
	"./56 - Seu Jorge - Amiga Da Minha Mulher.mp3": 185,
	"./57 - Sister Nancy - Bam Bam.mp3": 186,
	"./58 - Donna Summer - Spring Affair.mp3": 187,
	"./59 - Yellowman - Zungguzungguguzungguzeng.mp3": 188,
	"./6 - Miel De Montagne - Relax le plexus.mp3": 189,
	"./60 - Nu Guinea - Ddoje Facce.mp3": 190,
	"./61 - Marcos Valle - Estrelar.mp3": 191,
	"./62 - Caribou - Odessa.mp3": 192,
	"./63 - Toro Y Moi - Girl Like You.mp3": 193,
	"./64 - Les Sins - Grind.mp3": 194,
	"./65 - Shintaro Sakamoto - Let's Dance Raw.mp3": 195,
	"./66 - Michel Polnareff - Holidays.mp3": 196,
	"./67 - Laurent Voulzy - Le Coeur Grenadine.mp3": 197,
	"./68 - Michael Jackson - Stranger in Moscow.mp3": 198,
	"./69 - Lucio Battisti - Ancora tu.mp3": 199,
	"./7 - Futuro Pelo - Swamp.mp3": 200,
	"./70 - Wham - Everything She Wants.mp3": 201,
	"./71 - Maya - Lait de coco (Dub).mp3": 202,
	"./72 - Gonzaguinha - Lindo Lago Do Amor.mp3": 203,
	"./73 - Mild High Club - Homage.mp3": 204,
	"./74 - Cocteau Twins - Cherry-coloured Funk.mp3": 205,
	"./75 - Fern Kinney - Love Me Tonight (Love, Love, Love).mp3": 206,
	"./76 - Andrea Laszlo De Simone - Immensità.mp3": 207,
	"./77 - DeBarge - I Like It.mp3": 208,
	"./78 - Khruangbin - Texas Sun.mp3": 209,
	"./79 - Yves Simon - Au pays des merveilles de Juliet.mp3": 210,
	"./8 - Domenique Dumont - Sans cesse, mon chéri.mp3": 211,
	"./80 - George Michael - Freedom '90 (Remastered).mp3": 212,
	"./81 - Pierre Vassiliu - Qui c'est celui-là _.mp3": 213,
	"./82 - Giorgio Moroder - In the Middle of the Knight (Remastered).mp3": 214,
	"./83 - Stretch - Why did you do it.mp3": 215,
	"./84 - Mac Demarco - Chamber Of Reflection.mp3": 216,
	"./85 - Muddy Monk - En Lea.mp3": 217,
	"./86 - sir Was - Deployed (feat. Little Dragon).mp3": 218,
	"./87 - Kurt Vile - Wakin on a Pretty Day.mp3": 219,
	"./88 - Ariel Pink's Haunted Graffiti - Baby (feat. DamFunk).mp3": 220,
	"./89 - Alain Chamfort - Bambou (Pilooski _ Jayvich Reprise).mp3": 221,
	"./9 - Petit Prince - Un été sans amour (Moodoïd Remix).mp3": 222,
	"./90 - Miel De Montagne - Pourquoi pas.mp3": 223,
	"./91 - Jacques - Dans la radio (Futuro Pelo Remix).mp3": 224,
	"./92 - UTO - The Beast.mp3": 225,
	"./93 - infinite bisous - Teen Sex.mp3": 226,
	"./94 - Khruangbin - Time (You and I).mp3": 227,
	"./95 - The Undercover Dream Lovers - You Don't Have to be Lonely.mp3": 228,
	"./96 - Faux Real - Boss Sweet.mp3": 229,
	"./97 - James Righton - Edie.mp3": 230,
	"./98 - Yves Tumor - Strawberry Privilege.mp3": 231,
	"./99 - Aaron Childs - Good Times.mp3": 232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;